<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Confirm Time-Off Request</h3>
</div>
<div class="modal-body" style="max-height: 500px; overflow: auto;">
    <table class="table">
        <thead>
            <tr>
                <th *ngIf="requestType !== 'P'"><strong>Request Type</strong></th>
                <th *ngIf="requestType === 'P'"><strong>Partial Day</strong></th>
                <th *ngIf="requestType === 'P'"><strong>Dates</strong></th>
                <th></th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let request of requests">
                <td>{{request.RequestString}}</td>
                <td>{{request.DateString}}</td>
                <td>{{request.Hours | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</td>
            </tr>
            <tr *ngIf="leaveCodeID!=-1 && !hideInitRemainHourModal">
                <td></td>
                <td *ngIf="leaveCodeID!=-1"><b>Initial Hours:</b></td>

                <td *ngIf="leaveCodeID!=-1">{{projectedInitial | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</td>
            </tr>
            <tr>
                <td></td>
                <td><b>Total Requested:</b></td>
                <td>{{total | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</td>
            </tr>
            <tr *ngIf="leaveCodeID!=-1 && !hideInitRemainHourModal">
                <td></td>
                <td><b>New Balance:</b></td>
                <td>{{newBalance | daysAndHours:settings.timeOffUnits:stdWorkdayHours}}</td>
            </tr>
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="submitClicked()">
        Submit
    </button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">
        Cancel
    </button>
</div>